<template>
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
      <!-- Left navbar links -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#"><i class="fas fa-bars"></i></a>
        </li>
        <li class="nav-item d-none d-sm-inline-block breadcrumb-item">
          <a href="/" class="nav-link">首页</a>
        </li>
        
      </ul>


      <!-- Right navbar links -->
      <ul class="navbar-nav ml-auto">
        <!-- Messages Dropdown Menu -->
        <li class="nav-item dropdown">
          <a class="nav-link" data-toggle="dropdown" href="#">
            欢迎：{{userName}}
          </a>
        </li>
        <!-- Notifications Dropdown Menu -->

        <li class="nav-item dropdown">
          <a class="nav-link" data-toggle="dropdown" href="#">
            <i class="fa fa-power-off"></i>
          </a>
          <div class="dropdown-menu dropdown-menu dropdown-menu-right">
            <a href="javascript:void(0);" @click="modifyPassword" class="dropdown-item dropdown-footer">
              修改密码
            </a>
            <a href="javascript:void(0);" @click="exit" class="dropdown-item dropdown-footer">退出</a>
          </div>
        </li>

      </ul>

    </nav>
</template>

<script>
import { api, buff } from "@/api/api.js";
import { mapState, mapMutations } from "vuex";

export default {
  
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  computed: {
    ...mapState("userModule", ["userName"])
  },
  methods: {
    ...mapMutations("userModule", ["clear_user"]),

    exit:function(){
      this.clear_user({});
      this.$router.push('/login');
    },
    modifyPassword(){

      this.$router.push('/modify-password');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar{padding: 0 .5rem;}
.main-header .nav-link{height: auto;}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue